
class UserType {
    static Admin = 0;
    static CPF = 1;
    static CNPJ = 2;
}

export default UserType;